import { useState } from "react";
import api from "@/modules/growing-circle/lib/api";
import { useAuth } from "@/modules/growing-circle/context/AuthContext";
import { HandHeart, Flag, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function TestimonyCard({ t, onChange }) {
  const { user } = useAuth();
  const [ack, setAck] = useState(t.acknowledged_by_me);
  const [pulse, setPulse] = useState(false);

  const acknowledge = async () => {
    setPulse(true);
    setTimeout(() => setPulse(false), 500);
    try {
      const { data } = await api.post(`/testimonies/${t.id}/acknowledge`);
      setAck(data.acknowledged);
    } catch {}
  };

  const report = async () => {
    try {
      await api.post("/reports", { target_type: "testimony", target_id: t.id, reason: "Report from a member" });
      toast.success("Thank you, the report has been sent to the administrators.");
    } catch {}
  };

  const remove = async () => {
    try {
      await api.delete(`/testimonies/${t.id}`);
      toast.success("Testimony removed.");
      onChange?.();
    } catch {}
  };

  return (
    <div className="bg-card border border-border rounded-3xl p-8" data-testid={`testimony-${t.id}`}>
      {t.title && <h3 className="font-heading text-2xl mb-2">{t.title}</h3>}
      <p className="text-foreground leading-relaxed whitespace-pre-wrap">{t.body}</p>
      <div className="flex items-center justify-between mt-6">
        <span className="text-sm text-accent">— {t.author_name}</span>
        <div className="flex items-center gap-2">
          {!t.is_owner && (
          <button onClick={acknowledge} data-testid={`acknowledge-btn-${t.id}`}
            className={`flex items-center gap-2 text-sm rounded-full px-4 py-2 border transition-colors duration-300 ${
              ack ? "bg-accent/15 border-accent/40 text-accent" : "border-border text-muted-foreground hover:text-foreground"
            } ${pulse ? "scale-105" : ""}`}>
            <HandHeart className="w-4 h-4" /> {ack ? "I heard you" : "I'm listening"}
          </button>
          )}
          {t.is_owner || user?.role === "admin" ? (
            <button onClick={remove} className="p-2 text-muted-foreground hover:text-destructive transition-colors" title="Remove" data-testid={`delete-testimony-${t.id}`}>
              <Trash2 className="w-4 h-4" />
            </button>
          ) : (
            <button onClick={report} className="p-2 text-muted-foreground hover:text-foreground transition-colors" title="Report" data-testid={`report-testimony-${t.id}`}>
              <Flag className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
      {t.heard_count != null && (
        <p className="text-xs text-muted-foreground mt-3">Heard by {t.heard_count} {t.heard_count === 1 ? "person" : "people"}</p>
      )}
    </div>
  );
}
